import axios from 'axios'
import {clearToken, getToken} from './auth';

const baseURL = process.env.REACT_APP_BASE_URL

const api = axios.create({
    baseURL,
    timeout: 60000,
    headers: {
        Accept: 'application/json',
    },
})

api.interceptors.request.use((config) => {
    const token = getToken()
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }

    return config
}, (error) => Promise.reject(error))

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401 && !window.location.pathname.startsWith('/login')) {
            clearToken()
            window.location.replace('/login')
        }

        return Promise.reject(error)
    }
)

export async function request({
    url,
    method = 'get',
    data = null,
    query = {},
    headers = {},
    onUploadProgress,
    cancelToken,
}) {
    const response = await api.request({
        url,
        method,
        params: query,
        data,
        headers: {
            ...headers,
        },
        onUploadProgress,
        cancelToken,
    })
    return response.data
}
